import { OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
var CallTranscriptComponent = /** @class */ (function () {
    function CallTranscriptComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.transcriptData = [];
    }
    CallTranscriptComponent.prototype.ngOnInit = function () {
        this.transcriptData = this.data.split('\n').slice(0, -1);
    };
    CallTranscriptComponent.prototype.closePanel = function () {
        this.bsModalRef.hide();
        if (this.onClose) {
            this.onClose.next('close');
            this.onClose.complete();
        }
    };
    return CallTranscriptComponent;
}());
export { CallTranscriptComponent };
